export default {
  signs: `/v1/signs/signs`,
  sign: (id: string) => `/v1/signs/signs/${id}`,
  sign_skills: (id: string) => `/v1/signs/skill_locals/${id}`,
  skills: `/v1/signs/skills`,
  sign_users: `/v1/signs/sign_users`,
  sign_user: (id: string) => `/v1/signs/sign_users/${id}`,
  users: `/v1/signs/users`
};
